import {useRef} from 'react'

export default function useFirstMountState(): boolean {
	const isFirst = useRef(true)

	if (isFirst.current) {
		isFirst.current = false

		return true
	}

	return isFirst.current
}
